var _filter, _g, _ellipse, _g2, _path, _path2, _ellipse2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardErrorDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 350 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 144,
    width: 206,
    x: 62,
    y: 100.286
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "erode",
    radius: 4,
    result: "effect1_dropShadow_269_7642"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_269_7642"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    operator: "erode",
    radius: 4,
    result: "effect2_dropShadow_269_7642"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_269_7642",
    mode: "normal",
    result: "effect2_dropShadow_269_7642"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_269_7642",
    mode: "normal",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1e2129"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 74,
    cy: 111.429,
    rx: 5,
    ry: 4.28571
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 186,
    rx: 9,
    ry: 7.71429
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 260,
    cy: 105.429,
    rx: 6,
    ry: 5.14286
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165,
    cy: 150,
    fill: "#11141a",
    rx: 80,
    ry: 68.5714
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#1e2129",
    height: 104,
    rx: 6,
    width: 166,
    x: 82,
    y: 100.286
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.0703 126.472c0-1.105.8954-2 2-2h25.0237c1.104 0 2 .895 2 2v17.767c0 1.105-.896 2-2 2h-25.0237c-1.1046 0-2-.895-2-2z",
    fill: "#505666"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.837,
    cy: 131.728,
    fill: "#6d7587",
    r: 12.093
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.325,
    cy: 131.728,
    fill: "#505666",
    r: 12.093
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#404757"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m96.0703 188.565c0-1.336 1.0829-2.419 2.4186-2.419h24.1861c1.336 0 2.419 1.083 2.419 2.419 0 1.335-1.083 2.418-2.419 2.418h-24.1861c-1.3357 0-2.4186-1.083-2.4186-2.418z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.349 188.565c0-1.336 1.083-2.419 2.419-2.419h24.186c1.336 0 2.419 1.083 2.419 2.419 0 1.335-1.083 2.418-2.419 2.418h-24.186c-1.336 0-2.419-1.083-2.419-2.418z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.628 188.565c0-1.336 1.083-2.419 2.419-2.419h24.186c1.336 0 2.419 1.083 2.419 2.419 0 1.335-1.083 2.418-2.419 2.418h-24.186c-1.336 0-2.419-1.083-2.419-2.418z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.908 188.565c0-1.336 1.082-2.419 2.418-2.419h24.186c1.336 0 2.419 1.083 2.419 2.419 0 1.335-1.083 2.418-2.419 2.418h-24.186c-1.336 0-2.418-1.083-2.418-2.418z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m243.524 168.531c2.378-3.531 7.574-3.531 9.952 0l17.737 26.331c2.684 3.986-.172 9.352-4.977 9.352h-35.472c-4.805 0-7.661-5.366-4.977-9.352z",
    fill: "#d13e3b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m246.256 196.5c0-.31.071-.616.209-.902s.341-.546.596-.765c.256-.219.559-.392.892-.511.334-.118.692-.179 1.053-.179s.719.061 1.052.179c.334.119.637.292.892.511.256.219.458.479.597.765.138.286.209.592.209.902 0 .625-.29 1.225-.806 1.667-.515.442-1.215.69-1.944.69s-1.429-.248-1.945-.69c-.515-.442-.805-1.042-.805-1.667zm.269-14.155c-.036-.297 0-.598.108-.882.108-.285.284-.547.517-.769.234-.222.519-.4.838-.521.319-.122.663-.185 1.012-.185s.694.063 1.013.185c.319.121.604.299.837.521.234.222.41.484.518.769.107.284.144.585.107.882l-.962 8.267c-.039.32-.215.617-.495.833-.279.215-.642.335-1.018.335s-.738-.12-1.018-.335c-.279-.216-.455-.513-.494-.833z",
    fill: "#000"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 264,
    cy: 84.857,
    fill: "#1e2129",
    rx: 4,
    ry: 3.42857
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardErrorDark);
export default __webpack_public_path__ + "static/media/CardErrorDark.f27d8537b4fba1e6f52b78af9a2d9584.svg";
export { ForwardRef as ReactComponent };